import { cn } from '@/lib/utils';
import Button from '@/shared/components/ui/Button';

interface BottomPaymentProps {
  totalPrice?: number;
  onClick?: () => void;
  disabled?: boolean;
  textButton?: string;
  title?: string;
  stylePrice?: string;
}

const formatPrice = (price: number) => {
  return new Intl.NumberFormat('id-ID').format(price);
};

const BottomPayment = ({
  totalPrice = 0,
  textButton,
  stylePrice,
  title,
  onClick,
  disabled = false,
}: BottomPaymentProps) => {
  return (
    <div className="fixed inset-x-0 bottom-0 z-10 mx-auto flex w-full items-center gap-3 bg-white px-6 py-3 lg:max-w-[60%] md:max-w-[80%]">
      <div className="flex w-full flex-1 flex-col items-center justify-between gap-3">
        <div className="flex w-full items-center justify-between">
          <p className="body2 text-text-grey">{title}</p>

          <p className={cn('title1bold', stylePrice)}>Rp {formatPrice(totalPrice)}</p>
        </div>

        <div className="flex w-full flex-1">
          <Button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className="title1medium btn-fill-blue flex-1 px-8 "
          >
            {textButton}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BottomPayment;
